<template>
  <div :class="['EDU_MAIN','theme_'+this.$route.params.version]">
    <h1>
        <!-- .    education2 -->
        EDUCATION
    </h1>
    <div>
      <div :class="['edu','mx-2xl']">

          <div v-for="(item, index) in children" class="eduItem" :key="'edu_col_'+index">            
            <div class="title">
              <img src="https://www.mis-implants.com/upload/education/icons/Education-Library.png" />
              <h3>{{item.title}}</h3>
            </div>
            <p v-for="child in item.children" :key="child">
              {{child}}
            </p>
          </div>
      </div>
    </div>
  </div>
</template>

<!-- v3 -->
<style scoped>
    .EDU_MAIN
    {
        width: 100%;
        min-height: 50vh;
        padding-top: 80px;
        padding-bottom: 200px;
        text-align: center;
    }
    .EDU_MAIN h1
    {
        margin: auto;text-align: center;
        width: 100%;
    }
    .edu
    {
        background-color: #3a3a3a;
        width: 90vw;
        margin-top:30px;
        border-radius: 20px;
        /* padding: 50px; */
        display: flex;
        gap: 0px;              /* space between columns */
        align-items: stretch;   /* stretch children to same (tallest) height */

    }
    .eduItem
    {
      flex: 1 1 0;            /* grow & shrink equally, base width 0 to distribute evenly */
      padding: 50px 80px;
      /* border-radius: 10px; */
      display: flex;         /* make column a column-flex so we can align content inside */
      flex-direction: column;
      /* border: solid 1px #fff; */
      color: #fff;
      text-align: left;
      /* border: solid 1px red; */
      transition: all ease 0.3s;
    }
    .eduItem:nth-child(1),
    .eduItem:nth-child(2)
    {
      /* border-right: solid 1px #ccc; */
    }

    .eduItem:hover
    {
      background-color: #1894e2;
    }
    .eduItem:nth-child(1):hover
    {
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    }
    .eduItem:nth-child(2):hover
    {
      border-radius: 20px;
    }
    .eduItem:nth-child(3):hover
    {
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }

    .eduItem .title img
    {
      width: 50px;height: auto;
      padding-bottom: 12px;
    }

    .eduItem h3
    {
        margin: 0 0 20px 0; 
        font-size: 22px;
    }

    @media (max-width: 680px) {
      .edu {
        flex-direction: column;
      }
    }

</style>






<script>
  import { mapActions, mapState } from "vuex";

  export default 
  {
    data(){
      return{
        activeIndex: 0,
        minisite_ready:false,
        children:[
            {
                title:"MIS Global Education Program",
                icon:"",
                children:["Education Program","Webinars on Demand"]
            },
            {
                title:"Education Library",
                icon:"",
                children:["Clinical Cases","Pro Tips","Videos","Lectures","Downloads","User Manuals"]
            },
            {
                title:"MEET",
                icon:"",
                children:["MIS Expert Experience Team"]
            }        
          ]
      }
    },  
    components:
    {
        /* ResearchOps */
    }, 
    computed: {
        //...mapState(["siteData","siteDataReady","siteReady","minisite_VisibleSection","pageLayoutData"]),

  },
  methods:
  {

  },
  mounted()
  {
    var vm=this;
    //this.setActiveIndex(0);
  },
  created()  
  {            
}   
  
  }
</script>


